import { e as extensions } from './matchers-35e4d3bd.mjs';
import 'redent';
import '@adobe/css-tools';
import 'dom-accessibility-api';
import 'aria-query';
import 'picocolors';
import 'css.escape';

expect.extend(extensions);
